import styled from '@emotion/styled';
import {
  OL_COLOUR_BLACK_55_HEX,
  OL_COLOUR_BLACK_90_HEX,
  OL_COLOUR_NAVY_BABY,
} from '../../../components/Style/colours';
import { TextField } from '../../../components/TextField/component';

export const Container = styled('div')({
  paddingBottom: 16,
  '.ol-select.pageSize': {
    marginLeft: 0,
  },
});

export const Table = styled('table')({
  width: '100%',
  fontSize: 14,
  marginTop: 12,
  marginBottom: 18,
  border: 'solid 1px #D8D8D8',
  borderRadius: 4,

  a: {
    textDecoration: 'underline',
  },

  'th, td': {
    textAlign: 'left',
    padding: '16px 20px',
    borderBottom: 'solid 1px #D8D8D8',
    color: OL_COLOUR_BLACK_90_HEX,
  },

  th: {
    fontWeight: 600,
  },

  td: {
    fontWeight: 400,
    color: OL_COLOUR_BLACK_55_HEX,

    '&.action-column': {
      width: '150px',
    },
  },

  'tr td:first-child': {
    textAlign: 'left',
    fontWeight: 600,
    textDecoration: 'none',

    'a, a:hover, a:visited': {
      color: `${OL_COLOUR_NAVY_BABY} !important`,
    },
  },

  'tr td:first-child, tr th:first-child': {
    borderRight: 'solid 1px #D8D8D8',
  },
});

export const Heading = styled('div')({
  fontSize: 18,
  borderBottom: '1px solid #CACACA',
  fontWeight: 600,
  lineHeight: '35px',
  marginBottom: 20,
});

export const SubHeading = styled('div')({
  fontSize: 16,
  fontWeight: 600,
  marginTop: 24,
  marginBottom: 8,
});

export const VSpace = styled('div')({
  height: 8,
});

export const UserRow = styled('div')({
  display: 'flex',
  margin: '2px 0',
});

export const UserIcon = styled('img')({
  width: 23,
  height: 23,
  marginRight: 6,
});

export const StyledTextField = styled(TextField)({
  width: 530,
  'input.ol-text-field-text': {
    height: 47,
  },
});
